import { useRef, useCallback, useEffect } from 'react';
import umlSelectionEngine from '../../Core/UmlSelectionEngine';
import umlCanvasEngine from '../../Core/UmlCanvasEngine';

/**
 * D-key shape deletion shortcut. Tracks the currently hovered shape (event
 * delegation on the world div, via handleWorldMouseOver) and removes it on D,
 * unless focus is on an inline-edit input/textarea.
 * @returns {{handleWorldMouseOver: Function}}
 */
export default function useShapeDeleteShortcut() {
    const hoveredShapeIdRef = useRef(null);

    const handleWorldMouseOver = useCallback(function trackHoveredShape(event) {
        const shapeEl = event.target.closest('[data-shape-id]');
        hoveredShapeIdRef.current = shapeEl ? shapeEl.getAttribute('data-shape-id') : null;
    }, []);

    useEffect(function attachShapeDeleteListener() {
        function onKeyDown(event) {
            if (event.key.toLowerCase() !== 'd') return;
            if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') return;
            const shapeId = hoveredShapeIdRef.current;
            if (!shapeId) return;
            if (umlSelectionEngine.selectedId === shapeId) {
                umlSelectionEngine.clear();
            }
            umlCanvasEngine.removeShape(shapeId);
        }
        window.addEventListener('keydown', onKeyDown, true);
        return function detachShapeDeleteListener() {
            window.removeEventListener('keydown', onKeyDown, true);
        };
    }, []);

    return { handleWorldMouseOver };
}
